module.exports = __webpack_public_path__ + "img/applepay.04030e6.svg";